import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { isEmpty } from 'lodash'
import data from '../../content/header/oldheader.en-XC.yaml'

/*
  This top header component
  This gets top nav as props
*/

export default function OldHeader({ user = {}, location = {} }) {
  const [loginURL, setLoginURL] = useState('')
  const [logoutURL, setLogoutURL] = useState('')
  const [launcher, setLauncher] = useState(null)

  const isDocs = null,
    isSupport = null,
    isAPIs = null
  let product = null

  useEffect(() => {
    if (!isEmpty(user)) {
      setLoginURL(
        user.login.url.replace(/PAGEURL/g, encodeURIComponent(location.href)),
      )
      setLogoutURL(
        user.logout.url.replace(/PAGEURL/g, encodeURIComponent(location.href)),
      )
    }
  }, [location.href, user])

  useEffect(() => {
    setLauncher(
      typeof window !== `undefined` ? require('@paypalcorp/dx-ui-react') : null,
    )
  }, [])

  const renderLogInBtn = (loginURL) => {
    return (
      <div className="dx-auth-logged-out">
        <a
          className="dx-auth-login dx-btn dx-btn-primary"
          data-js="auth-btn"
          href={loginURL}
          data-dxa="login,nav-click,nav-login"
        >
          Log in to Dashboard
        </a>
      </div>
    )
  }

  const renderProfileComponent = (user, logoutURL) => {
    return (
      <div tabIndex="0" className="dx-auth dx-auth-logged-in profile__wrap">
        <div id="dx-profile-dropdown-btn" className="profile__trigger">
          <div className="profile__letter--wrap dx-bg-grad-radial-blue">
            <span className="profile__letter">
              {user.firstName && user.firstName.charAt(0)}
            </span>
          </div>
          <div className="profile__name">{user.firstName}</div>
        </div>
        <div id="dx-profile-dropdown" className="profile__dropdown">
          <ul className="profile__dropdown__list">
            <li className="profile__dropdown__item">
              <Link
                className="dx-home-content profile__dropdown__link profile__dropdown__link--dashboard"
                data-enable-spinner="/dashboard/"
                to="/dashboard/"
              >
                {data.content.dashboard}
              </Link>
            </li>
            <li className="profile__dropdown__item">
              <Link
                className="profile__dropdown__link profile__dropdown__link--my-account"
                data-enable-spinner="/developer/accountStatus/"
                to="/developer/accountStatus/"
              >
                {data.content.my_account}
              </Link>
            </li>
            <li className="profile__dropdown__item">
              <Link
                className="dx-auth-logout profile__dropdown__link profile__dropdown__link--logout"
                data-js="auth-btn"
                to={logoutURL}
                data-bypass="true"
              >
                {data.content.log_out}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    )
  }

  return (
    <header className="header vx_globalNav-main" id="header">
      <Link
        className="header__block header__brand"
        to="/"
        aria-label={data.content.site_name}
      />
      <Link
        className="header__block dx-trigger-nav-0"
        data-trigger-nav="dx-nav-open-0"
        aria-label={data.content.toggle_top_nav}
      />
      <div
        className="dx-trigger-nav-2"
        data-trigger-nav="dx-nav-open-2"
        data-product="{product}"
      >
        {product}
      </div>
      <div
        className={`header__nav ${user.loggedIn ? 'userloggedInHeader' : ''} `}
      >
        <div className="header__nav--left">
          <ul className="dx-nav-0 dx-nav-0-docs">
            <li className={`dx-nav-0-item ${isDocs}`}>
              <Link className="dx-nav-0-link" to={data.content.nav_hd_1_url}>
                {data.content.nav_hd_1_title}
              </Link>
              <ul className="dx-nav-0-sub">
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_1_1_url}
                  >
                    {data.content.nav_hd_1_1_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_1_1_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_1_2_url}
                  >
                    {data.content.nav_hd_1_2_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_1_2_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_1_3_url}
                  >
                    {data.content.nav_hd_1_3_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_1_3_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_1_4_url}
                  >
                    {data.content.nav_hd_1_4_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_1_4_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_1_5_url}
                  >
                    {data.content.nav_hd_1_5_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_1_5_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item dx-nav-0-sub-index">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_1_6_url}
                  >
                    {data.content.nav_hd_1_6_title}
                  </Link>
                </li>
              </ul>
            </li>
            <li className={`dx-nav-0-item ${isAPIs}`}>
              <Link className="dx-nav-0-link" to={data.content.nav_hd_2_url}>
                {' '}
                {data.content.nav_hd_2_title}
              </Link>
              <ul className="dx-nav-0-sub">
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_2_1_url}
                  >
                    {data.content.nav_hd_2_1_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_2_1_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_2_2_url}
                    target="_blank"
                  >
                    {data.content.nav_hd_2_2_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_2_2_sub_title}
                  </span>
                </li>
              </ul>
            </li>
            <li className={`dx-nav-0-item ${isSupport}`}>
              <Link className="dx-nav-0-link" to={data.content.nav_hd_3_url}>
                {' '}
                {data.content.nav_hd_3_title}
              </Link>
              <ul className="dx-nav-0-sub">
                <li className="dx-nav-0-sub-item dx-nav-0-sub-index">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_3_1_url}
                  >
                    {data.content.nav_hd_3_1_title}
                  </Link>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_3_2_url}
                  >
                    {data.content.nav_hd_3_2_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_3_2_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_3_3_url}
                  >
                    {data.content.nav_hd_3_3_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_3_3_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_3_4_url}
                  >
                    {data.content.nav_hd_3_4_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_3_4_sub_title}
                  </span>
                </li>
                <li className="dx-nav-0-sub-item">
                  <Link
                    className="dx-nav-0-sub-link"
                    to={data.content.nav_hd_3_5_url}
                  >
                    {data.content.nav_hd_3_5_title}
                  </Link>
                  <span className="dx-nav-0-desc">
                    {data.content.nav_hd_3_5_sub_title}
                  </span>
                </li>
              </ul>
            </li>
          </ul>
          {launcher && <launcher.SearchLauncher />}
        </div>

        <div className="header__nav--right">
          <div
            className={`dx-auth-block ${
              user.loggedIn ? 'dx-authed' : ''
            } profile__container`}
          >
            {user.loggedIn
              ? renderProfileComponent(user, logoutURL)
              : renderLogInBtn(loginURL)}
          </div>
          <div
            id="dx-auth-info"
            hidden
            data-login-url={loginURL}
            data-logout-url={logoutURL}
          />
        </div>
      </div>
    </header>
  )
}
